import { render } from "./armazemForm.vue?vue&type=template&id=3946f359&scoped=true"
import script from "./armazemForm.vue?vue&type=script&lang=js"
export * from "./armazemForm.vue?vue&type=script&lang=js"

import "./armazemForm.vue?vue&type=style&index=0&id=3946f359&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3946f359"]])

export default __exports__